interface ListingComponent {
  button: HTMLButtonElement;
  items: HTMLElement[];
  currentlyVisibleCount: number;
  readonly itemsPerLoad: number;
}

class BlockListingContacts {
  private components: Map<HTMLElement, ListingComponent> = new Map();
  private readonly itemsPerLoad: number = 5;
  private readonly initiallyVisible: number = 5;

  constructor() {
    const containers = document.querySelectorAll<HTMLElement>('[data-listing-document]');
    containers.forEach(container => {
      this.setupComponent(container);
    });
  }

  private setupComponent(container: HTMLElement): void {
    const button = container.querySelector<HTMLButtonElement>('[data-listing-document-more]');
    const list = container.querySelector<HTMLElement>('[data-listing-document-list]');

    if (!button || !list) {
      return;
    }

    const items = Array.from(list.querySelectorAll<HTMLElement>('[data-listing-document-item]'));

    const componentState: ListingComponent = {
      button,
      items,
      itemsPerLoad: this.itemsPerLoad,
      currentlyVisibleCount: this.initiallyVisible,
    };

    this.components.set(container, componentState);

    if (componentState.currentlyVisibleCount >= componentState.items.length) {
      componentState.button.style.display = 'none';
    }

    componentState.button.addEventListener('click', () => this.loadMore(componentState));
  }

  private loadMore(component: ListingComponent): void {
    const nextLimit = component.currentlyVisibleCount + component.itemsPerLoad;

    for (let i = component.currentlyVisibleCount; i < nextLimit && i < component.items.length; i++) {
      component.items[i].classList.add('visible');
    }

    component.currentlyVisibleCount = nextLimit;

    if (component.currentlyVisibleCount >= component.items.length) {
      component.button.style.display = 'none';
    }
  }
}

export const blockListingContacts = new BlockListingContacts();